import type { ReactNode } from 'react';

/**
 * 원본 prize_modify.php · settings.php 의 표 한 줄 - 왼쪽 제목, 오른쪽 입력. 날짜+시각처럼 입력이
 * 둘 이상이면 as="div" 로 둔다 (<label> 은 안의 첫 입력에만 클릭을 넘긴다).
 */
export function FormRow({
  label,
  error,
  as = 'label',
  children,
}: {
  label: string;
  error?: string | undefined;
  as?: 'label' | 'div';
  children: ReactNode;
}) {
  const Tag = as;
  return (
    <Tag className="lottery-prize-form__row">
      <span className="lottery-prize-form__label">{label}</span>
      <span className="lottery-prize-form__control">
        {children}
        {error ? (
          <span className="field__error" role="alert">
            {error}
          </span>
        ) : null}
      </span>
    </Tag>
  );
}
